<div class="index_page_outer">
  <app-breadcrumb-list
    [partsOfUrl]="partsOfUrl()"
    [dark_backdrop]="true"
    [transparent]="true"
    [standard_max_width]="true"
  />
  <div class="index_content">
    <h1>
      {{ 'PAGES.TIPS_INDEX.H1_PREFIX' | translate }}
      {{ activeCategoryTitle() }}
    </h1>

    <div class="list-group">
      @if (loading()) {
        <div class="isLoading">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
      } @else {
        @if (parentIndexPath()) {
          <p class="index_parent_link">
            <a [routerLink]="parentIndexPath()"
              >{{ 'PAGES.TIPS_INDEX.ALL_IN_PARENT' | translate }}
              {{
                index()?.parentCategory?.title || index()?.parentCategory?.slug
              }}</a
            >
          </p>
        }
        @if (subCategories().length) {
          <h2>{{ 'PAGES.TIPS_INDEX.SUB_CATEGORIES_TITLE' | translate }}</h2>
          @for (subCategory of subCategories(); track subCategory.asCat) {
            <div class="list-group-item">
              <div class="list-group-item-inner">
                <h5 class="mb-1">
                  <a [routerLink]="subCategory.indexPath"
                    >{{ subCategory.title || subCategory.slug }} ({{
                      subCategory.count
                    }})</a
                  >
                </h5>
              </div>
            </div>
          }
          @if (tips().length) {
            <h2>{{ 'PAGES.TIPS_INDEX.DIRECT_TIPS_TITLE' | translate }}</h2>
          }
        }
        @for (tip of tips(); track $index) {
          <div class="list-group-item">
            <div class="list-group-item-inner">
              <div class="view_Count">
                <mat-icon>remove_red_eye</mat-icon>
                <p>{{ $safeNavigationMigration(tip?.viewCount) | number }}</p>
              </div>
              <h5 class="mb-1">
                <a [routerLink]="linkFor(tip)">{{ tip.title }}</a>
              </h5>
            </div>
          </div>
        }
      }
    </div>
    <app-lp-footer />
  </div>
</div>
